import { render } from "./ActionFooter.vue?vue&type=template&id=be3ddcf6"
import script from "./ActionFooter.vue?vue&type=script&lang=js"
export * from "./ActionFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__